const inValidErr = "Invalid input";

export const AddAndUpdateUpdates = {
  formId: "AddAndUpdateUpdates",
  formInp: [
    {
      inp: {
        InputLabelProps: {
          shrink: true,
        },
        type: "text",
        label: "Work title",
        name: "title",
        id: "title",
        required: true,
        fullWidth: true,
        helperText: inValidErr,
      },
      grid: 12,
    },
  
    {
      inp: {
        InputLabelProps: {
          shrink: true,
        },
        type: "text",
        label: "Work description",
        name: "description",
        id: "description",
        rows: 6,
        multiline: true,
        fullWidth: true,
        helperText: inValidErr,
      },
      grid: 12,
    },
    {
      inp: {
        hidden: true,
        type: "file",
        accept: "image/*",
        label: "Choose an image",
        name: "image",
        id: "raised-button-file",
        helperText: inValidErr,
        required: true,
      },
      grid: 12,
    },

    {
      inp: {
        type: "alert",
      },
      grid: 12,
    },
    {
      inp: {
        type: "submit",
        label: "Add updates",
        editLabel: "Edit update",
        loaderLabel: "Adding data...",
        name: "add",
        id: "add",
        variant: "contained",
        className: "btn-std1",
        fullWidth: true,
        service: {
          editUrl:process.env.REACT_APP_API_URL + `api/update_data`,
          url: process.env.REACT_APP_API_URL + `api/add_data`,
          method: "POST",
          params: { type: "sv_updates" },
        },
      },
      grid: 12,
    },
  ],
};
